import { Command } from 'commander';
import { ConnectContextService } from '../../services/connect-context.service.js';
import { redactSecret, redactUrl } from './shared.js';

interface ListOptions {
    json?: boolean;
}

export function createConnectListCommand(): Command {
    return new Command('list')
        .description('List detected environments and available connections')
        .option('-j, --json', 'Output JSON')
        .action(function (this: Command, options: ListOptions) {
            const context = new ConnectContextService();
            const summaries = context.summarize();
            const useJson = !!(options.json || this.optsWithGlobals().json);
            const showSecrets = context.getSettings().redaction.showSecrets;

            if (useJson) {
                const redacted = summaries.map((summary) => ({
                    ...summary,
                    connections: summary.connections.map((connection) => ({
                        ...connection,
                        url: redactUrl(connection.url, showSecrets),
                        password: redactSecret(connection.password, showSecrets),
                    })),
                }));
                console.log(JSON.stringify({ envs: redacted }, null, 2));
                return;
            }

            if (summaries.length === 0) {
                console.log('No environment file detected for connect settings.');
                return;
            }

            for (const summary of summaries) {
                const connNames = summary.connections.map((c) => c.name).join(', ') || 'none';
                console.log(`${summary.env.padEnd(12)} ${connNames}`);
            }
        });
}
